module.exports = __webpack_public_path__ + "static/Mauer1@2x.3d41c23e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHeader/MauerBack/Mauer1@2x.png
// module id = 429
// module chunks = 35783957827783